import React from "react";
import { Button, InputNumber, List, Space } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { BrickSeries } from "../../store/slices/bricksSlice";

interface Props {
  brick: BrickSeries;
  onClick?(): void;
  onDelete?(): void;
  rate: number;
  onRateInput(val: number): void;
}

export const SelectedStoneRow: React.FC<Props> = ({
  brick,
  onClick,
  rate,
  onRateInput,
  onDelete,
}) => {
  return (
    <List.Item onClick={() => onClick?.()} style={{ display: "flex" }}>
      <List.Item.Meta
        avatar={<img width={100} src={brick.thumbnail} />}
        title={brick.name}
      />
      <Space>
        <InputNumber
          value={rate}
          defaultValue={100}
          min={0}
          max={100}
          step={5}
          formatter={(value) => `${value ?? 0}%`}
          parser={(value) => parseInt((value ?? "0").replace("%", ""))}
          onChange={(val) => onRateInput(val ?? 0)}
        />
        <Button danger onClick={onDelete} icon={<DeleteOutlined />} />
      </Space>
    </List.Item>
  );
};
